export const useCoreStore = defineStore('core', () => {
  const meterTypes = ref<CoreMeterTypes>([]);

  // Actions
  const setConstants = async (data: CoreConstantsApiResponse) => {
    meterTypes.value = data.meter_types;
  };

  return { meterTypes, setConstants };
});
